import React from 'react'


export default function Header(props) {
 
  return (
    <h1> JEOPARDY GENERATOR</h1>
  )
}